import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/http-general.service';
import { CONFIG } from '../../shared/config';
import { AppCodeGroup } from '..';

let linkDetailsUrl = CONFIG.baseUrls.linkDetails;


export interface AppCodes {
    code: number,
    nameEn: string;
    nameAr: string;
    iconName: string;
    cssClasses: string;
    serial: number;

    disabled?: boolean;
    visible?: boolean;
}

@Injectable()
export class TabService {
    constructor(private httpGeneralService: HttpGeneralService) {
      linkDetailsUrl =  linkDetailsUrl.replace(CONFIG.Urls.apiUrlOld, CONFIG.Urls.apiUrlNew);
    }

    // getControls(LinkId: number, controlType: any, required: boolean) {
    //     return this.httpGeneralService.getWith(`${linkDetailsUrl}/${LinkId}/${controlType}/${required}`);
    // }
    getControls(LinkId: number, controlType: AppCodeGroup, required: boolean, componentName: string, category: string) {
        if (componentName == undefined) componentName = '0';
        if (category == undefined) category = '0';
        let data:any={}
        data.linkId=LinkId,
        data.appComponentName=componentName,
        data.category=category,
        data.controlType=controlType

        return this.httpGeneralService.post<any>(data, `${linkDetailsUrl}/TabsPermissions`);

       // return this.httpGeneralService.getWith(`${linkDetailsUrl}/${LinkId}/TabsPermissions/${controlType}/${componentName}/${category}`);
      }

}
